import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../../shared/components/Buttons';
import { ButtonVariant } from '../../../../shared/components/Buttons/types';
import InlineLayout from '../../../../shared/layout/inlineLayout';
import { useViewAdmin, PROFILE_NAV_ITEMS } from '../../hooks/useViewAdmin';
import ViewAdminContent from './viewAdminContent';
import ViewAdminErrorScreen from './viewAdminErrorScreen';
import Loader from '@/app/routes/Loader';

const ViewAdminPage: React.FC<{ userId: string }> = ({ userId }) => {
  const navigate = useNavigate();
  const {
    user,
    showErrorScreen,
    initials,
    statusLabel,
    statusBadgeClasses,
    isLoading,
  } = useViewAdmin(userId);

  const profileHeader = (
    <>
      <div className="flex items-center gap-4">
        <div
          className="flex items-center justify-center shrink-0 rounded-full bg-[#E8EEF0] text-[#223746] font-medium"
          style={{
            width: '64px',
            height: '64px',
            fontSize: '22px',
            lineHeight: '32px',
          }}
        >
          {initials}
        </div>
      </div>
      <div className="flex min-w-0 flex-1">
        <div className="flex min-w-0 flex-col gap-[4px]">
          <div className="flex min-w-0 flex-col items-start gap-1">
            <h2
              className="min-w-0 break-all font-medium text-neutral-10"
              style={{
                fontSize: '18px',
                lineHeight: '28px',
              }}
            >
              {user?.name ?? '—'}
            </h2>
            <span
              className={`px-3 py-1 rounded-[8px] text-sm font-medium flex items-center gap-2 ${statusBadgeClasses.container}`}
              style={{
                fontSize: '14px',
                lineHeight: '20px',
              }}
            >
              <div
                className={`rounded-full shrink-0 ${statusBadgeClasses.dot}`}
                style={{
                  width: '6px',
                  height: '6px',
                }}
              />
              {statusLabel}
            </span>
          </div>
          {/* <span
            className="px-2 py-1 w-[100px] rounded-[8px] text-sm font-medium bg-information-90 text-information-30"
            style={{
              fontSize: '14px',
              lineHeight: '20px',
            }}
          >
            {userData.role}
          </span> */}
        </div>
      </div>
      <Button
        label="Edytuj Administratora"
        variant={ButtonVariant.Primary}
        size="Medium"
        onClick={() =>
          navigate(`/administrators/Edycja-Administratora/${userId}`)
        }
        className="!py-[10px] !px-[16px] !font-medium !text-[14px] hover:cursor-pointer"
        style={{ borderRadius: '8px' }}
      />
    </>
  );
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <React.Fragment key={userId}>
      {showErrorScreen ? (
        <ViewAdminErrorScreen />
      ) : (
        <InlineLayout
          title="Podgląd Administratora "
          navItems={[...PROFILE_NAV_ITEMS]}
          contentByNavId={{
            PodstawoweInformacje: <ViewAdminContent user={user ?? null} />,
          }}
          header={profileHeader}
          searchParamKey="tab"
          defaultActiveId="PodstawoweInformacje"
        />
      )}
    </React.Fragment>
  );
};

export default ViewAdminPage;
